import React from 'react';
import { Link } from 'react-router-dom';
import { toIdentifierMask } from '../../services/mask';
import PersonType from '../../enums/PersonType';

interface InvoicePersonProps {
  title: string;
  name: string;
  alias?: string | null;
  identifier: string;
  editAction: string;
  identifierType: PersonType;
}
export default function InfoPerson({
  title,
  name,
  alias,
  identifier,
  identifierType,
  editAction,
}: InvoicePersonProps) {
  return (
    <fieldset className='border p-4 rounded'>
      <legend>{title}</legend>
      <div>
        <div className='d-flex'>
          <strong>Nome:&nbsp;</strong>
          <Link to={editAction} target='_blank'>
            {name}
          </Link>
        </div>
        <br />
        {alias && (
          <>
            <div className='d-flex'>
              <strong>Nome Fantasia:&nbsp;</strong>
              {alias}
            </div>
            <br />
          </>
        )}
        <strong>
          {identifierType === PersonType.Juridical ? 'CNPJ' : 'CPF'}:
        </strong>
        &nbsp;
        {toIdentifierMask(identifier, identifierType)}
      </div>
    </fieldset>
  );
}
